var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [!_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "questionSection"
    }
  }, [_vm.currentRound.dynamicContent ? _c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.dynamicContent
    }
  }) : _vm._e()], 1) : _vm._e(), !_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "dragAndDropSection"
    }
  }, [_c('div', {
    staticClass: "draggableArea"
  }, [_c('div', {
    staticClass: "draggableBankArea"
  }, _vm._l(_vm.currentRound.draggableItems, function (item) {
    var _item$image$image$src, _item$image, _item$image$image;
    return _c('div', {
      key: item.id,
      staticClass: "bankAreaItem",
      style: {
        height: _vm.imageHeight.drag
      },
      attrs: {
        "id": ("startingPoint-" + (item.id))
      }
    }, [_c('div', {
      staticClass: "draggableItem",
      attrs: {
        "id": ("draggable-" + (item.id))
      }
    }, [_c('div', {
      staticClass: "dragAndDropContent"
    }, [_c('img', {
      staticClass: "draggable-image",
      attrs: {
        "src": (_item$image$image$src = (_item$image = item.image) === null || _item$image === void 0 ? void 0 : (_item$image$image = _item$image.image) === null || _item$image$image === void 0 ? void 0 : _item$image$image.src) !== null && _item$image$image$src !== void 0 ? _item$image$image$src : '',
        "alt": ""
      }
    })])])]);
  }), 0)]), _c('div', {
    staticClass: "droppableArea"
  }, _vm._l(_vm.currentRound.dropZones, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "dropItemContainer"
    }, [_c('div', {
      staticClass: "titleText"
    }, [_c('html-renderer', {
      attrs: {
        "htmlObject": item.titleHtml
      }
    }), _c('div', {
      staticClass: "feedbackContainer"
    }, [_vm.shouldShowIcon(item, true) ? _c('CorrectIcon', {
      attrs: {
        "height": "100%",
        "width": "100%"
      }
    }) : _vm._e(), _vm.shouldShowIcon(item, false) ? _c('WrongIcon', {
      attrs: {
        "height": "100%",
        "width": "100%"
      }
    }) : _vm._e()], 1)], 1), _c('div', {
      staticClass: "category",
      style: _vm.getCategoryBorder(item),
      attrs: {
        "id": ("dropArea-" + (item.id))
      }
    }, [item.fixedItems ? _c('div', _vm._l(item.fixedItems, function (fixedItem) {
      var _fixedItem$image$imag, _fixedItem$image, _fixedItem$image$imag2;
      return _c('div', {
        key: fixedItem.id,
        staticClass: "fixedItem",
        style: {
          height: _vm.imageHeight.drop
        }
      }, [_c('img', {
        staticClass: "draggable-image",
        attrs: {
          "src": (_fixedItem$image$imag = (_fixedItem$image = fixedItem.image) === null || _fixedItem$image === void 0 ? void 0 : (_fixedItem$image$imag2 = _fixedItem$image.image) === null || _fixedItem$image$imag2 === void 0 ? void 0 : _fixedItem$image$imag2.src) !== null && _fixedItem$image$imag !== void 0 ? _fixedItem$image$imag : '',
          "alt": ""
        }
      })]);
    }), 0) : _vm._e()])]);
  }), 0)]) : _vm._e(), _vm.shouldShowKeyboard ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }